import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6h-6z"
}), 'TrendingUpTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/TrendingUpTwoTone.js
// module id = 6933
// module chunks = 2